<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('company.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('home'), href: '/' },
            {
              text: $t('company.pageTitle'),
              active: true
            }
          ]"
        />
      </div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <!-- <ts-button outline color="info" @click.prevent="addNew">{{
              $t('add_new')
            }}</ts-button> -->
            <div class="d-flex">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px;"
                class="inline-block"
              />
            </div>
          </div>
        </ts-card-wrapper>
        <Table
          :columns="columns"
          :data="resources"
          size="small"
          :loading="loading"
          highlight-row
          stripe
          max-height="700"
        >
          <template slot-scope="{ row }" slot="address">
            {{ $store.getters.limitStringShow(row.company_address) }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
          </template>
        </Table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
        <!-- form-action -->
        <a-modal
          v-if="showForm"
          v-model="showForm"
          :title="$t('company.pageTitle')"
          centered
          @cancel="clearEdit"
          :zIndex="1020"
          :footer="null"
        >
          <from-action
            @cancel="clearEdit"
          />
        </a-modal>
      </ts-card>
    </div>
  </template>
  
  <script>
  import { debounce } from 'lodash'
  import { mapState } from 'vuex'
  import FromAction from './form'
  
  export default {
    name: 'companyIndex2',
    components: {
      FromAction
    },
    data() {
      return {
        loading: false,
        showForm: false
      }
    },
    computed: {
      ...mapState('corporate/company', ['resources', 'pagination']),
      search: {
        get() {
          return this.$store.state.corporate.company.search
        },
        set(newValue) {
          this.$store.commit('corporate/company/SET_SEARCH', newValue)
          this.$store.commit('corporate/company/RESET_CURRENT_PAGE')
        }
      },
      columns() {
        return [
          {
            title: this.$t('company.companyNameKH'),
            key: 'company_name_kh'
          },
          {
            title: this.$t('company.companyNameEN'),
            key: 'company_name_en'
          },
          {
            title: this.$t('company.phone'),
            key: 'company_phone'
          },
          {
            title: this.$t('company.address'),
            slot: 'address'
          },
          {
            title: this.$t('company.website'),
            key: 'company_website'
          },
          {
            title: this.$t('actions'),
            key: 'action',
            slot: 'action',
            fixed: 'right',
            align: 'center',
            width: 90
          }
        ]
      }
    },
    methods: {
      fetchData(attributes) {
        this.loading = true
        this.$store
          .dispatch('corporate/company/fetch', { ...attributes })
          .then(response => {
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$toasted.error(error.message)
          })
      },
      addNew() {
        this.showForm = true
      },
      edit(record) {
        this.$store.commit('corporate/company/SET_EDIT_DATA', record)
        this.showForm = true
      },
      clearEdit(){
        this.$store.commit('corporate/company/SET_EDIT_DATA', {})
        this.showForm = false
        this.fetchData()
      }
    },
    watch: {
      search: debounce(function(search) {
        this.fetchData()
      }, 500)
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fetchData()
      })
    },
    beforeRouteLeave(to, from, next) {
      this.$store.commit('corporate/company/RESET_STATE')
      next()
    }
  }
  </script>
  